module.exports = __webpack_public_path__ + "img/Soundcloud.33d38e12.webp";